<template lang="pug">
  v-app.application
    div
      mobile-header(v-if="$vuetify.breakpoint.smAndDown")
      main-header(v-else)
    v-main
      transition(name="slide-x-transition" mode="out-in")
        router-view
    main-footer
</template>

<script>
import MainHeader from './components/MainHeader.vue';
import MobileHeader from './components/MobileHeader.vue';
import MainFooter from './components/MainFooter.vue';

export default {
  name: 'App',
  components: {
    MainHeader,
    MobileHeader,
    MainFooter,
  },
  data: () => ({
    //
  }),
  computed: {},
  created() {
    // if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') {
    //   window.location.href = 'https://sertelecom.com.br';
    // };
  }
};
</script>

<style lang="sass">
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

html *
  font-family: $primary-font

.application
  overflow-x: hidden

.max-content 
  +media-min-lg
    max-width: 90%
    margin: auto
    padding: 0 16px
  +media-min-xl

h1
  font-size: 28px
  +media-min-md
    font-size: 44px
h2
  font-size: 24px
  +media-min-md
    font-size: 32px
h3
  font-size: 20px
  +media-min-md
    font-size: 28px

.v-btn.v-btn--rounded
  height: auto !important
  padding: 8px 32px !important
  +media-min-md
    padding: 0 32px !important
</style>
